class Quote {
	static parseMessage(quote) {
		if (!quote.messages) return quote;
		quote.lastMessage = quote.messages.reverse()[0];
		quote.messages = undefined;

		return quote;
	}

	static getFirstProviderMessage(quote) {
		if (!quote.messages) return quote;
		quote.lastProviderMessage = quote.messages.find(
			(message) => message.from_provider
		);
		quote.messages = undefined;

		return quote;
	}
}

export default Quote;
